import axios from "axios";
// send email
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const url = API_BASE_URL;

// send email
export const sendEmail = async (email, utm_data, environmentInfo) => {
  try {
    const data = await axios.post(`https://srvr.rxpt.ai/api/auth/LoginWithEmailOTP`, {
      email,
      utm_data,
      environmentInfo,
    });
    return data.data;
  } catch (error) {
    console.error(
      "Error sending email OTP:",
      error?.response?.data || error.message
    );
    return error;
  }
};
// get customer api

const getCustomer = async (email) => {
  try {
    const { data } = await axios.post(`https://srvr.rxpt.ai/api/customer`, { email });
    console.log("✅ Customer ID fetched:", data.customerId);
    return data.customerId;
  } catch (err) {
    console.error(
      "❌ Error fetching customer ID:",
      err.response?.data || err.message
    );
    throw err;
  }
};
// verify otp api
export const verifyEmailOtp = async (email, otp) => {
  try {
    const customerId = await getCustomer(email);
    const { data } = await axios.post(`https://srvr.rxpt.ai/api/auth/verifyEmailOTP`, {
      email,
      otp: otp?.join(""),
      customerId,
    });

    console.log("✅ OTP Verified:", data);

    return data;
  } catch (err) {
    console.error("Error verifying OTP:", err.response?.data || err.message);
    return err;
  }
};
//  create checkout api
export default async function createCheckoutUrl(planTitle, interval) {
  const payload = {
    planName: planTitle,
    interval,
  };
  try {
    const res = await axios.post(
      `https://srvr.rxpt.ai/api/create-checkout-session-url`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
      }
    );
    const url = res?.data?.url;
    if (!url) {
      throw new Error("Checkout API did not return a 'url'.");
    }
    return url;
  } catch (err) {
    const status = err?.response?.status;
    const msg =
      err?.response?.data?.message ||
      err?.message ||
      "Unknown error calling checkout API";
    throw new Error(
      status
        ? `Checkout API failed (${status}): ${msg}`
        : `Checkout API failed: ${msg}`
    );
  }
}
// create involved lead
export const createInvolvedLead = async (payload) => {
  try {
    const { data } = await axios.post(`https://srvr.rxpt.ai/api/involved/CreateInvolvedLeads`, {
      ...payload,
    });
    return data;
  } catch (error) {
    console.error(
      " Error creating involved lead:",
      error?.response?.data || error.message
    );
    throw error;
  }
};
// verify captcha
export const verifyCaptcha = async (token) => {
  try {
    const { data } = await axios.post(`https://srvr.rxpt.ai/api/verify-captcha`, { token });
    return data;
  } catch (error) {
    console.error(
      "Error verifying captcha:",
      error?.response?.data || error.message
    );
    throw error;
  }
};
// get agent details
export const getAgentDetails = async (agentId) => {
  try {
    const { data } = await axios.get(
      `https://srvr.rxpt.ai/api/agentV2/getAgentDetailsByQuickSetupCode/${agentId}`
    );
    return data;
  } catch (error) {
    return error;
  }
};
// quick agent create call
export const createWidgetWebCall = async (agentIds) => {
  try {
    const { data } = await axios.post(
      `https://srvr.rxpt.ai/api/agent/createPublicWidgetWebCall`,
      { agent_id: agentIds, url: "https://agent.rxpt.ai" }
    );
    return data;
  } catch (error) {
    console.error(
      "Error creating widget web call:",
      error?.response?.data || error.message
    );
    throw error;
  }
};
//  create quick agent payment page
export const createQuickAgentPayment = async (
  agentId,
  userId,
  priceId,
  agentName,
  businessName,
  ventryUrl
) => {
  try {
    const sucessUrl = `https://app.rexpt.in/thankyou/update?agentId=${agentId}&userId=${userId}&isAdmin=true&agentName=${agentName}&agentCode=${ventryUrl}&businessName=${businessName}&isFree=true`;
    const cancelUrl = "https://rexptin.vercel.app";
    const { data } = await axios.post(
      `https://srvr.rxpt.ai/api/free-trail/SZDFLLKJNdSQWCCSDZ`,
      { agentId, userId, priceId, sucessUrl, cancelUrl }
    );
    return data;
  } catch (error) {
    console.error(
      "Error creating widget web call:",
      error?.response?.data || error.message
    );
    throw error;
  }
};
// lib/Store.js
export const SubmitKnowledgeBase = async ({
  fullName,
  email,
  website,
  googleMyBusiness,
  businessCategory,
}) => {
  try {
    const { data } = await axios.post(
      `https://srvr.rxpt.ai/api/quick-agent/create`,
      {
        fullName,
        email,
        website,
        googleMyBusiness,
        businessCategory,
      }
    );
    return data;
  } catch (error) {
    console.error(
      "Error creating quick agent setup:",
      error?.response?.data || error.message
    );
    throw error;
  }
};
// fetch telnyx number
export const fetchTelnyxNumber = async ({
  country,
  phone_number_type = "",
  features = "",
  limit = "",
  starts_with = "",
  ends_with = "",
}) => {
  try {
    // Build query string properly
    const queryParams = new URLSearchParams({
      country_code: country,
      locality: "",
      administrative_area: "",
      phone_number_type,
      features,
      limit,
      starts_with,
      ends_with,
    }).toString();

    const { data } = await axios.get(
      `https://srvr.rxpt.ai/api/telnyx/available-numbers?${queryParams}`
    );
    const firstNumber = data?.data?.[0]?.phone_number || null;

    return firstNumber;
  } catch (error) {
    console.error(
      "Error fetching telnyx number:",
      error?.response?.data || error.message
    );
    throw error;
  }
};
export const updateAgent = async (data) => {
  try {
    const response = await axios.patch(`https://srvr.rxpt.ai/api/agentV2/updateAgentDetails`, data)
    return response
  } catch (error) {
    return error
  }
}
export const validateWebsite = async (websiteUrl) => {
  try {
    const res = await axios.post(`https://srvr.rxpt.ai/api/validate-website`, { website: websiteUrl });
    return res.data;
  } catch (error) {
    console.error("Error validating website:", error);
    return { valid: false, reason: "Error validating website" };
  }
};


export const listSiteMap = async (url) => {
  try {
    const response = await axios.post(
      `https://srvr.rxpt.ai/api/map/list-sitemap2`,
      { url }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error deleting agent file:",
      error.response?.data || error.message
    );
    throw new Error("Error deleting agent file");
  }
};